module.exports = __webpack_public_path__ + "static/media/genre_analysis.65348772.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/genre_analysis.png
// module id = 384
// module chunks = 16